import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { IRiskOption } from "src/core/constants/options";
import { CustomRiskLevel } from "src/core/constants/risk";
import { ListElement, ListElementWithRisk, useMissionsListQuery } from "src/core/gql/graphql";
import { mapRiskCategory } from "src/core/mappers/risk-category.mapper";

export const useMissionTypeWithRiskOptions = (): {
  missionTypeWithRiskOptions: IRiskOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: missionTypeList, loading, error } = useMissionsListQuery();

  const missionTypeWithRiskOptions: IRiskOption[] = useMemo(() => {
    if (!missionTypeList?.listElements) return [];

    const missionsType = missionTypeList.listElements.filter(
      (element): element is ListElementWithRisk & ListElement =>
        "riskValues" in element && Array.isArray(element.riskValues)
    );

    return missionsType.map((missionType) => {
      const defaultRisk = missionType.riskValues.find((risk) => risk.key === "default");
      const risk = defaultRisk ? mapRiskCategory(defaultRisk.riskCategory) : CustomRiskLevel.LOW;

      return {
        id: missionType.id,
        value: missionType.code,
        label: missionType.name,
        risk,
      };
    });
  }, [missionTypeList]);

  return { missionTypeWithRiskOptions, loading, error };
};
